import React from 'react';
import { CheckCircle2, ChevronRight, Upload, Eye, Link2, FileSpreadsheet, Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

export const STEPS = [
  { key: 'upload',   label: 'Upload',          icon: Upload },
  { key: 'preview',  label: 'Preview',         icon: Eye },
  { key: 'map',      label: 'Mapping',         icon: Link2 },
  { key: 'validate', label: 'Validate',        icon: CheckCircle2 },
  { key: 'schema',   label: 'Generate Schema', icon: FileSpreadsheet },
  { key: 'publish',  label: 'Publish',         icon: Sparkles },
];

export default function UploadStepper({ step }) {
  return (
    <div className="px-6 py-3 border-b border-slate-100 bg-slate-50/50">
      <div className="flex items-center gap-1 overflow-x-auto">
        {STEPS.map((s, i) => {
          const active = i === step;
          const done = i < step;
          const Icon = s.icon;
          return (
            <React.Fragment key={s.key}>
              <div className={cn('flex items-center gap-2 px-2 py-1', active && 'font-semibold')}>
                <span className={cn(
                  'w-7 h-7 rounded-full flex items-center justify-center border-2 transition flex-shrink-0',
                  done ? 'bg-emerald-500 text-white border-emerald-500'
                    : active ? 'bg-[#CC0000] text-white border-[#CC0000]'
                    : 'bg-white text-slate-400 border-slate-300'
                )}>
                  {done ? <CheckCircle2 className="w-3.5 h-3.5" /> : <Icon className="w-3.5 h-3.5" />}
                </span>
                <span className={cn('text-xs whitespace-nowrap', active ? 'text-slate-900' : done ? 'text-emerald-700' : 'text-slate-400')}>
                  {i + 1}. {s.label}
                </span>
              </div>
              {i < STEPS.length - 1 && <ChevronRight className="w-3.5 h-3.5 text-slate-300 flex-shrink-0" />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
